import React from 'react';
import { Insight } from '@/api/insightsApi';
import { ScheduleDelayRiskVisualization } from './ScheduleDelayRiskVisualization';
import { NegativeFloatVisualization } from './NegativeFloatVisualization';
import { OpenEndsVisualization } from './OpenEndsVisualization';
import { ResourceUnderutilizationVisualization } from './ResourceUnderutilizationVisualization';
import { ResourceOverallocationVisualization } from './ResourceOverallocationVisualization';
import { ExcellentProgressVisualization } from './ExcellentProgressVisualization';
import { ScheduleCompressionVisualization } from './ScheduleCompressionVisualization';
import { DefaultImpactVisualization } from './DefaultImpactVisualization';

interface ImpactVisualizationProps {
  insight: Insight | null;
}

/**
 * Main router component that renders the appropriate visualization
 * based on the insight type/title
 */
export const ImpactVisualization: React.FC<ImpactVisualizationProps> = ({ insight }) => {
  if (!insight) return null;

  const title = insight.title;

  // Route to appropriate visualization component based on insight title
  switch (title) {
    case 'Schedule Delay Risk':
      return <ScheduleDelayRiskVisualization insight={insight} />;
    
    case 'Negative Float Detected':
      return <NegativeFloatVisualization insight={insight} />;
    
    case 'Open Ends Detected':
      return <OpenEndsVisualization insight={insight} />;
    
    case 'Resource Underutilization':
      return <ResourceUnderutilizationVisualization insight={insight} />;
    
    case 'Resource Over-allocation':
      return <ResourceOverallocationVisualization insight={insight} />;
    
    case 'Excellent Progress':
      return <ExcellentProgressVisualization insight={insight} />;
    
    case 'Schedule Compression Opportunity':
      return <ScheduleCompressionVisualization insight={insight} />;
    
    default:
      return <DefaultImpactVisualization insight={insight} />;
  }
};



